import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {InViewportModule} from 'ng-in-viewport';
import {GoogleMapLoaderComponent} from '../components/maps/components/google-map-loader/google-map-loader.component';
import {CareproviderUnitService} from '../services/careprovider-unit.service';
import {SharedModule} from './shared.module';
import {OpenningHoursSmallV2Component} from '../components/careprovider/openning-hours-small-v2/openning-hours-small-v2.component';
import {GoogleMapQuickLoaderV2Component} from '../components/careprovider/google-map-quick-loader-v2/google-map-quick-loader-v2.component';
import {CarouselComponent} from '../components/carousel/carousel.component';
import {ClosebyProviderCardV2Component} from '../components/careprovider/closeby-provider-card-v2/closeby-provider-card-v2.component';
import {ShortDomainPipe} from '../pipes/shortdomain.pipe';
import {StaffMemberComponent} from '../components/careprovider/staff-member/staff-member.component';
import {StaffMemberDetailsModal} from '../components/careprovider/staff-member-details-modal/staff-member-details-modal.component';
import {ExternalReviewsComponent} from '../components/careprovider/external-reviews/external-reviews.component';
import {LineRatingComponent} from '../components/line-rating/line-rating.component';
import {RatingsListComponent} from '../components/careprovider/ratings-list/ratings-list.component';
import {CpruContactComponent} from '../components/careprovider/cpru-contact/cpru-contact.component';
import {CareServiceListComponent} from '../components/careprovider/care-service-list/care-service-list.component';
import {CpruStaffListComponent} from '../components/careprovider/cpru-staff-list/cpru-staff-list.component';
import {CpruOpenHoursComponent} from '../components/careprovider/cpru-open-hours/cpru-open-hours.component';
import {CpruMapComponent} from '../components/careprovider/cpru-map/cpru-map.component';
import {BookingBtnComponent} from '../components/booking-btn/booking-btn.component';
import {CpruCtaContactComponent} from '../components/careprovider/cpru-cta-contact/cpru-cta-contact.component';
import {TimeslotButtonComponent} from '../components/careprovider/timeslot-button/timeslot-button.component';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {UiButtonComponent} from '../components/ui/ui-button/ui-button.component';
import {UiIconButtonComponent} from '../components/ui/ui-icon-button/ui-icon-button.component';
import {UiIconComponent} from '../components/ui/ui-icon/ui-icon.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    InViewportModule,
    MatTooltipModule,
    // SearchWidgetV2Module,
    BookingBtnComponent,
    TimeslotButtonComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    UiButtonComponent,
    UiIconButtonComponent,
    UiIconComponent,
  ],
  providers: [CareproviderUnitService],
  declarations: [
    CpruContactComponent,
    GoogleMapLoaderComponent,
    OpenningHoursSmallV2Component,
    GoogleMapQuickLoaderV2Component,
    CarouselComponent,
    ClosebyProviderCardV2Component,
    ShortDomainPipe,
    StaffMemberComponent,
    StaffMemberDetailsModal,
    ExternalReviewsComponent,
    LineRatingComponent,
    RatingsListComponent,
    CareServiceListComponent,
    CpruStaffListComponent,
    CpruOpenHoursComponent,
    CpruMapComponent,
    CpruCtaContactComponent,
  ],
  bootstrap: [],
  exports: [
    GoogleMapLoaderComponent,
    InViewportModule,
    OpenningHoursSmallV2Component,
    GoogleMapQuickLoaderV2Component,
    CarouselComponent,
    ClosebyProviderCardV2Component,
    ShortDomainPipe,
    StaffMemberComponent,
    StaffMemberDetailsModal,
    ExternalReviewsComponent,
    LineRatingComponent,
    RatingsListComponent,
    CpruContactComponent,
    CareServiceListComponent,
    CpruStaffListComponent,
    CpruOpenHoursComponent,
    CpruMapComponent,
    CpruCtaContactComponent,
  ],
})
export class SharedCareproviderModule {}
